import { useEffect } from "react";
import { siteMeta } from "../data/siteData";

const setMetaTag = (selector, attr, value) => {
  if (!value) return;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    const [, key, name] = selector.match(/^meta\[(name|property)="([^"]+)"\]$/) || [];
    if (key && name) {
      element.setAttribute(key, name);
      document.head.appendChild(element);
    } else {
      return;
    }
  }
  element.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  if (!href) return;
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
};

export const useSEO = ({ title, description, path = "/", image, type = "website" } = {}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${siteMeta.brand}` : siteMeta.defaultTitle;
    const desc = description || siteMeta.defaultDescription;
    const url = `${siteMeta.siteUrl}${path}`;
    const ogImage = image || siteMeta.defaultOgImage;

    document.title = fullTitle;

    setMetaTag('meta[name="description"]', "content", desc);
    setMetaTag('meta[property="og:title"]', "content", fullTitle);
    setMetaTag('meta[property="og:description"]', "content", desc);
    setMetaTag('meta[property="og:url"]', "content", url);
    setMetaTag('meta[property="og:image"]', "content", ogImage);
    setMetaTag('meta[property="og:type"]', "content", type);
    setMetaTag('meta[name="twitter:title"]', "content", fullTitle);
    setMetaTag('meta[name="twitter:description"]', "content", desc);
    setMetaTag('meta[name="twitter:image"]', "content", ogImage);
    setLink("canonical", url);
  }, [title, description, path, image, type]);
};
